import CssBaseline from '@mui/material/CssBaseline';
import type { ThemeProviderProps as MuiThemeProviderProps } from '@mui/material/styles';
import { ThemeProvider as ThemeVarsProvider } from '@mui/material/styles';

import { useSettingsContext } from '../components/settings/context/use-settings-context';
import { createTheme } from './create-theme';
import type {} from './extend-theme-types';
import type { ThemeOptions } from './types';
import { Rtl } from './with-settings/right-to-left';

export type ThemeProviderProps = Partial<MuiThemeProviderProps> & {
    themeOverrides?: ThemeOptions;
};

/**
 * Theme provider.
 * @param param {@link ThemeProviderProps}
 */
export function ThemeProvider({ themeOverrides, children, ...other }: ThemeProviderProps) {
    const settings = useSettingsContext();

    const theme = createTheme({
        settingsState: settings.state,
        themeOverrides,
    });

    return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <ThemeVarsProvider disableTransitionOnChange theme={theme} {...other}>
            <CssBaseline />
            <Rtl direction={settings.state.direction!}>{children}</Rtl>
        </ThemeVarsProvider>
    );
}
